const APP_VARIABLES = {
    SimpleToast: 'ts',
    AppLoading: 'al',
  },
  STRG_OPT = {type: 2}

const RgxMobileDevice =
  /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i
export {APP_VARIABLES, STRG_OPT, RgxMobileDevice}
